var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C11.0711 9 12.75 7.32107 12.75 5.25C12.75 3.17893 11.0711 1.5 9 1.5C6.92893 1.5 5.25 3.17893 5.25 5.25C5.25 7.32107 6.92893 9 9 9Z",
    fill: "#22222A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.875C5.2425 10.875 2.1825 13.395 2.1825 16.5C2.1825 16.71 2.3475 16.875 2.5575 16.875H15.4425C15.6525 16.875 15.8175 16.71 15.8175 16.5C15.8175 13.395 12.7575 10.875 9 10.875Z",
    fill: "#22222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserview);
export default __webpack_public_path__ + "static/media/userview.c2dd9d9e99aa68d0d1b44c331611801e.svg";
export { ForwardRef as ReactComponent };